import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/wordmark.svg'
import _imports_1 from '@/assets/icons/menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-de8ae6e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between py-6 px-2 max-w-screen-xl mx-auto w-screen overflow-hidden sm:px-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-6 md:h-7"
}, null, -1))
const _hoisted_3 = { class: "flex items-center flex-row-reverse md:flex-row" }
const _hoisted_4 = { class: "items-center hidden md:flex md:flex-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 md:hidden" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "h-6 ml-4 opacity-70 cursor-pointer"
  })
], -1))
const _hoisted_6 = { class: "md:hidden" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 opacity-40 uppercase" }, "Wallet", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_menu_items = _resolveComponent("menu-items")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_connect_wallet = _resolveComponent("connect-wallet")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_menu_items)
      ]),
      _createVNode(_component_n_tooltip, {
        ref: "menu",
        trigger: "hover",
        placement: "bottom-end",
        "show-arrow": false,
        class: "mt-2 w-[200px] md:hidden"
      }, {
        trigger: _withCtx(() => [
          _hoisted_5
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_menu_items, {
              vertical: "",
              onHide: _ctx.hideMenu
            }, null, 8, ["onHide"])
          ])
        ]),
        _: 1
      }, 512),
      (_ctx.showButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.walletConnected)
              ? (_openBlock(), _createBlock(_component_nomad_button, {
                  key: 0,
                  secondary: "",
                  responsive: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("div", null, _toDisplayString(_ctx.truncatedAddress), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_connect_wallet, {
                  key: 1,
                  primary: "",
                  responsive: ""
                }))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}